<template>
    <div id="histogram-picture-view" class="histogram-picture-view">
        <div
            class="picture-view__controls controls--top columns is-gapless is-mobile"
        >
            <div class="column is-one-fifth">
                <button
                    @click="turnClockwise()"
                    class="button"
                    style="transform: rotate(-45deg) translate3D(0, 2.5rem, 0)"
                >
                    <SvgIcon icon="icon--directional_arrow-right" />
                </button>
            </div>

            <div class="column is-three-fifths">
                <button
                    @click="turnUp()"
                    class="button"
                    style="transform: rotate(-90deg)"
                >
                    <SvgIcon icon="icon--directional_arrow-right" />
                </button>
            </div>
            <div class="column is-one-fifth"></div>
        </div>
        <div class="columns is-vcentered is-gapless is-mobile">
            <div class="column is-one-fifth">
                <button @click="turnLeft()" class="button">
                    <SvgIcon
                        icon="icon--directional_arrow-left"
                        style="transform: translateX(0.5rem)"
                    />
                </button>
            </div>
            <div class="column is-three-fifths">
                <div class="picture-view__image">
                    <LazyLoadedImage
                        :src="`${apiBaseUrl}${fullImageUrl}`"
                    ></LazyLoadedImage>
                </div>
            </div>
            <div class="column is-one-fifth">
                <button @click="turnRight()" class="button">
                    <SvgIcon
                        icon="icon--directional_arrow-right"
                        style="transform: translateX(-0.5rem)"
                    />
                </button>
            </div>
        </div>
        <div
            class="picture-view__controls controls--bottom columns is-gapless is-mobile"
        >
            <div class="column is-one-fifth"></div>
            <div class="column is-three-fifths">
                <button
                    @click="turnDown()"
                    class="button"
                    style="transform: rotate(90deg)"
                >
                    <SvgIcon icon="icon--directional_arrow-right" />
                </button>
            </div>
            <div class="column is-one-fifth">
                <button
                    @click="turnCounterClockwise()"
                    class="button"
                    style="transform: rotate(-45deg) translate3D(0, -2.5rem, 0)"
                >
                    <SvgIcon icon="icon--directional_arrow-right" />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import LazyLoadedImage from '../../shared/LazyLoadedImage';
import SvgIcon from '../../svg/SvgIcon';

export default {
    name: 'RepairPictures',
    components: { SvgIcon, LazyLoadedImage },
    data() {
        return {
            currentRotationDegree: 0,
            currentRotationTopAxis: 'X',
            currentRotationTopAxisDirection: 'P',
            apiBaseUrl: process.env.VUE_APP_FULFILLMENT_API_BASE_URL,
        };
    },
    methods: {
        nextAxis(axis) {
            switch (axis) {
                case 'X':
                    return 'Y';
                case 'Y':
                    return 'Z';
                case 'Z':
                    return 'X';
            }
        },
        previousAxis(axis) {
            switch (axis) {
                case 'X':
                    return 'Z';
                case 'Y':
                    return 'X';
                case 'Z':
                    return 'Z';
            }
        },
        calculateNewDegree(degree, plusOrMinus, rotateBy) {
            if (plusOrMinus === 'P') {
                degree = degree / 1 + rotateBy / 1;

                if (degree >= 360) degree = degree - 360;

                if (degree < 0) degree = degree + 360;

                return degree;
            }

            if (plusOrMinus === 'M') {
                degree = degree / 1 - rotateBy / 1;

                if (degree >= 360) degree = degree - 360;

                if (degree < 0) degree = degree + 360;

                return degree;
            }
        },
        turnUp() {
            let newDegree = 0;
            if (
                this.currentRotationDegree === 0 ||
                this.currentRotationDegree === 180
            ) {
                this.currentRotationTopAxis = this.nextAxis(
                    this.currentRotationTopAxis
                );
            } else {
                this.currentRotationTopAxis = this.previousAxis(
                    this.currentRotationTopAxis
                );
            }

            if (this.currentRotationDegree === 0) {
                newDegree = this.calculateNewDegree(
                    this.currentRotationDegree,
                    this.currentRotationTopAxisDirection,
                    -90
                );
            } else {
                newDegree = this.calculateNewDegree(
                    this.currentRotationDegree,
                    this.currentRotationTopAxisDirection,
                    90
                );
            }

            if (
                this.currentRotationDegree === 0 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 0 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 90 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 90 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 180 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 180 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 270 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 270 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            }

            this.currentRotationDegree = newDegree;
        },
        turnDown() {
            let newDegree = 0;

            if (
                this.currentRotationDegree === 0 ||
                this.currentRotationDegree === 180
            ) {
                this.currentRotationTopAxis = this.nextAxis(
                    this.currentRotationTopAxis
                );
            } else {
                this.currentRotationTopAxis = this.previousAxis(
                    this.currentRotationTopAxis
                );
            }

            if (this.currentRotationDegree === 180) {
                newDegree = this.calculateNewDegree(
                    this.currentRotationDegree,
                    this.currentRotationTopAxisDirection,
                    -90
                );
            } else {
                newDegree = this.calculateNewDegree(
                    this.currentRotationDegree,
                    this.currentRotationTopAxisDirection,
                    90
                );
            }

            if (
                this.currentRotationDegree === 0 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 0 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 90 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 90 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 180 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 180 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 270 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 270 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            }

            this.currentRotationDegree = newDegree;
        },
        turnClockwise() {
            let newDegree = 0;
            if (
                this.currentRotationDegree === 0 ||
                this.currentRotationDegree === 180
            ) {
                this.currentRotationTopAxis = this.previousAxis(
                    this.currentRotationTopAxis
                );
            } else {
                this.currentRotationTopAxis = this.nextAxis(
                    this.currentRotationTopAxis
                );
            }

            if (this.currentRotationDegree === 90) {
                newDegree = this.calculateNewDegree(
                    this.currentRotationDegree,
                    this.currentRotationTopAxisDirection,
                    -90
                );
            } else {
                newDegree = this.calculateNewDegree(
                    this.currentRotationDegree,
                    this.currentRotationTopAxisDirection,
                    90
                );
            }

            if (
                this.currentRotationDegree === 0 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 0 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 90 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 90 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 180 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 180 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 270 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 270 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            }

            this.currentRotationDegree = newDegree;
        },
        turnCounterClockwise() {
            let newDegree = 0;
            if (
                this.currentRotationDegree === 0 ||
                this.currentRotationDegree === 180
            ) {
                this.currentRotationTopAxis = this.previousAxis(
                    this.currentRotationTopAxis
                );
            } else {
                this.currentRotationTopAxis = this.nextAxis(
                    this.currentRotationTopAxis
                );
            }

            if (this.currentRotationDegree === 270) {
                newDegree = this.calculateNewDegree(
                    this.currentRotationDegree,
                    this.currentRotationTopAxisDirection,
                    -90
                );
            } else {
                newDegree = this.calculateNewDegree(
                    this.currentRotationDegree,
                    this.currentRotationTopAxisDirection,
                    90
                );
            }

            if (
                this.currentRotationDegree === 0 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 0 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 90 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 90 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 180 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 180 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            } else if (
                this.currentRotationDegree === 270 &&
                this.currentRotationTopAxisDirection === 'P'
            ) {
                this.currentRotationTopAxisDirection = 'P';
            } else if (
                this.currentRotationDegree === 270 &&
                this.currentRotationTopAxisDirection === 'M'
            ) {
                this.currentRotationTopAxisDirection = 'M';
            }

            this.currentRotationDegree = newDegree;
        },
        turnRight() {
            this.currentRotationDegree = this.currentRotationDegree - 90;
            if (this.currentRotationDegree === -90) {
                this.currentRotationDegree = 270;
            }
        },
        turnLeft() {
            this.currentRotationDegree = this.currentRotationDegree + 90;
            if (this.currentRotationDegree === 360) {
                this.currentRotationDegree = 0;
            }
        },
    },
    computed: {
        ...mapGetters(['current3DFile']),
        images() {
            return this.current3DFile.repairInfo.repairImages;
        },
        fullImageUrl() {
            return this.images[
                this.currentRotationTopAxis +
                    this.currentRotationTopAxisDirection +
                    '_' +
                    this.currentRotationDegree
            ];
        },
    },
};
</script>

<style scoped></style>
